import React from "react";
// import { useHistory } from "react-router-dom";

import { menuTitleEnums } from "@enums";
import { StyledToggleButton, TitleMenuComponent } from "..";
// import mobile_arrow_left from "@assets/Icons/arrow/mobile_arrow_left.svg";
import { StyledAlcohol } from ".";
import AlcoholCheckerTable from "./AlcoholCheckerTable";
import "../../App.css";
import AlcoholCheckedTable from "./AlcoholCheckedTable";

export const AlcoholCheck = () => {
  // hooks
  // const history = useHistory();
  // component state
  const [date, setDate] = React.useState(new Date());
  const [page, setPage] = React.useState<"confirm" | "confirmed">("confirm");
  // events
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = new Date(event.target.value); // Convert string to Date
    setDate(newDate);
  };

  const confirmPage = page === "confirm" && (
    <AlcoholCheckerTable date={date} />
  );

  const confirmedPage = page === "confirmed" && (
    <>
      <div className="al-detail__datePicker">
        <div className="label">作成日時</div>
        <div className="wrapperDatePicker">
          <input
            type="date"
            value={date.toISOString().split("T")[0]} // Format as YYYY-MM-DD
            onChange={handleChange}
            className="inputMonth"
          />
        </div>
      </div>
      <AlcoholCheckedTable date={date} />
    </>
  );

  return (
    <StyledAlcohol>
      {/* <AppTopBar /> */}
      {/* <CircularLoader loading={loading} /> */}
      <div className="al-detail">
        {/* <p
          className="al-detail__top-icon"
          onClick={() => history.push(appRouteEnums.PATH_HOME)}
        >
          <AppIconButton icon={<img src={mobile_arrow_left} alt="icon" />} />
        </p> */}
        <div className="al-detail__title">
          <TitleMenuComponent text={menuTitleEnums.TITLE_ALCOHOL_CHECK} />
        </div>

        <div className="buttonContainer">
          <div className="change-buttons">
            <StyledToggleButton onClick={() => setPage("confirm")} isActive={page === "confirm"}>
              未チェック
            </StyledToggleButton>
            <StyledToggleButton onClick={() => setPage("confirmed")} isActive={page === "confirmed"}>
              チェック済み
            </StyledToggleButton>
          </div>
        </div>


        {confirmPage}

        {confirmedPage}

        {/* <div className="al-detail__datePicker">
          <div className="label">作成日時</div>
          <div className="wrapperDatePicker">
            <input
              type="date"
              value={date.toISOString().split("T")[0]} // Format as YYYY-MM-DD
              onChange={handleChange}
              className="inputMonth"
            />
          </div>
        </div>
        <AlcoholCheckerTable date={date} /> */}
      </div>
    </StyledAlcohol>
  );
};
